import './styles.scoped.css';
export default {
  "segment": "awsui_segment_8cbea_1if1w_97",
  "disabled": "awsui_disabled_8cbea_1if1w_164",
  "selected": "awsui_selected_8cbea_1if1w_172",
  "icon": "awsui_icon_8cbea_1if1w_193",
  "with-text": "awsui_with-text_8cbea_1if1w_197",
  "with-no-text": "awsui_with-no-text_8cbea_1if1w_203",
  "root": "awsui_root_8cbea_1if1w_214",
  "segment-part": "awsui_segment-part_8cbea_1if1w_225",
  "select": "awsui_select_8cbea_1if1w_172",
  "segment-count-2": "awsui_segment-count-2_8cbea_1if1w_244",
  "segment-count-3": "awsui_segment-count-3_8cbea_1if1w_249",
  "segment-count-4": "awsui_segment-count-4_8cbea_1if1w_254",
  "segment-count-5": "awsui_segment-count-5_8cbea_1if1w_259",
  "segment-count-6": "awsui_segment-count-6_8cbea_1if1w_264"
};